import { useBudget } from 'hooks/useBudget';

import { useColumns } from 'data/tableData/catalogue/budgetColumns';

import { ClosedBudgetExport } from 'pages/Catalogue/components/Budget/components/ClosedBudgetExport';

import { Table } from 'components/Table';

import * as S from './List.styles';

export function List(): React.ReactElement {
  const { budgets, refetchBudgets } = useBudget();
  const columns = useColumns(refetchBudgets);

  return (
    <div>
      <S.CreateWrapper>
        <ClosedBudgetExport />

        <S.Create
          fontFamily="LFT Zeno Condensed"
          iconLeft="FiPlus"
          scale="lg"
          asLink
          to="new"
          motive="addNew"
          textTransform="uppercase"
        >
          Add new Budget
        </S.Create>
      </S.CreateWrapper>
      <Table tableName="budgets" columns={columns} data={budgets} hasPagination autoResetPage />
    </div>
  );
}
